import SuggestionNode from '../store/schema/SuggestionNode';
import { IEditor } from 'roosterjs-editor-types';
import { trace } from 'owa-trace';

export default function removeSuggestionFromEditor(
    editor: IEditor,
    suggestionToRemove: SuggestionNode
) {
    if (suggestionToRemove && editor) {
        editor.deleteNode(suggestionToRemove.suggestionNode);
    } else {
        trace.info('[Smart Compose] Could not remove suggestion from editor');
    }
}
